export const ampersandOptions = {
  project: import.meta.env.VITE_AMPERSAND_PROJECT_ID,
  apiKey: import.meta.env.VITE_AMPERSAND_API_KEY
};
